import { Component, ElementRef, Inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatDialog } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { SharedService } from '../../../shared/services/shared.service';
import { Efectivo } from '../../../models/finanzas/efectivo/efectivo.model';
import { EfectivoDialogFormComponent } from './efectivo-dialog-form.component';


@Component({
    selector: 'convfact-dialog-import-account-efectivo',
    templateUrl: './efectivo-dialog-importAccount.component.html',
    styleUrls: ['../bancos/bankaccount.component.css'],
    standalone: false
})
export class EfectivoDialogImportAccount {

    dataImport: Efectivo = this.data.dataImport;

    constructor(
        public dialogRef: MatDialogRef<EfectivoDialogFormComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public snackBar: MatSnackBar,
        public sharedService: SharedService
    ) { }

    startImport() {
        this.sharedService.importAccountsUpdate(this.dataImport, "Efectivo").then(result => {
            this.dialogRef.close();
        });
    }

    closeDialog() {
        this.dialogRef.close();
    }




}
